// src/components/RiskBadge.jsx
// Shared risk-level pill for the Subscriber portal (Guardian Dubai) — used by
// SubscriberDashboardPage and SubscriberBeneficiaryDetailPage. Extracted from
// two verbatim-duplicated copies so both pages stay in sync, and rendered via
// the shared .badge classes (index.css) to match the Navigator portal's own
// badges instead of a bespoke pill shape.
import React from 'react';

const RISK_BADGE_CLASS = {
  HIGH: 'badge-inactive',
  MODERATE: 'badge-pending',
  LOW: 'badge-active',
};

export default function RiskBadge({ level }) {
  const className = RISK_BADGE_CLASS[level];
  return (
    <span
      className={`badge${className ? ` ${className}` : ''}`}
      style={className ? undefined : { background: 'var(--bg-subtle)', color: 'var(--text-muted)' }}
    >
      {level || 'UNKNOWN'}
    </span>
  );
}
